import { render, staticRenderFns } from "./photo-header.vue?vue&type=template&id=68b3966f&scoped=true&"
import script from "./photo-header.vue?vue&type=script&lang=ts&"
export * from "./photo-header.vue?vue&type=script&lang=ts&"
import style0 from "./photo-header.vue?vue&type=style&index=0&id=68b3966f&prod&lang=scss&scoped=true&"
import style1 from "./photo-header.vue?vue&type=style&index=1&id=68b3966f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b3966f",
  null
  
)

export default component.exports